<template>
  <v-btn icon flat small @click="goRoute">
    <v-tooltip bottom>
      <v-icon slot="activator" color="primary">keyboard_arrow_right</v-icon>
      <span>Ver</span>
    </v-tooltip>
  </v-btn>
</template>

<script>
export default {
  props: {
    item: Object
  },

  methods: {
    goRoute () {
      if (this.$store.getters.isSafRole) {
        this.$router.push({ name: 'fichaClub', params: { idClub: this.item.clubId, idSubarea: this.item.subareaId } })
      } else {
        this.$router.push({ name: 'ficha', params: { id: this.item.subareaId } })
      }
    }
  }
}
</script>
